import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Space,
  Table,
  InputNumber,
  Card,
  Select,
  Row,
  Col,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";

import { useSelector, useDispatch } from "react-redux";
import Slider from "react-slick";
import { fileManagerActions } from "../../store";
import config from "../../consts/config";

import { LocalImage } from "../../components/ImageUtil";
import modulesApi from "../../api/module/modulesApi";
import UploadFile from "../../components/UploadFile";
import productApi from "../../api/product/productApi";
import { currencyFormat } from "../../utils";

const SliderProduct = (props) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);

  const [titleModal, setTitleModal] = useState("");
  const [isEditModal, setEditModal] = useState(false);
  const [valueFormData, setValueFormData] = useState({
    product: null,
    index: null,
    itemIndex: null,
  });

  const [products, setProducts] = useState([]);
  const [sliderItems, setSliderItems] = useState([]);
  const [productsShow, setProductsShow] = useState([]);

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  useEffect(() => {
    getProduct();
    getHomeFeaturedProductsSlider();
  }, []);

  useEffect(() => {
    form.setFieldsValue(valueFormData);
  }, [form, valueFormData, isEditModal]);

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const getHomeFeaturedProductsSlider = () => {
    setLoading(true);
    modulesApi
      .getHomeFeaturedProductsSlider()
      .then((res) => {
        if (res?.values !== null) {
          setLoading(false);
          const data = res?.values;
          setSliderItems(data);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getProduct = () => {
    const params = {
      published: true,
      page: 1,
      limit: 10000,
    };
    productApi.getProducts(params).then((res) => {
      if (res) {
        const data = res?.results.map((item) => {
          return { text: item.name, value: item.id };
        });
        setProducts(data);
        setProductsShow(res?.results);
      }
    });
  };

  const columns = [
    {
      title: "STT",
      render: (id, record, index) => {
        ++index;
        return index;
      },
      className: "text-center",
      width: "5%",
    },

    {
      title: "Ảnh hiển thị",
      dataIndex: "image",
      render: (image) => (
        <>
          <LocalImage
            src={image}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 250,
    },
    {
      title: "Sản phẩm",
      dataIndex: "product",
      render: (product) => <h3>{product.name}</h3>,
    },
    {
      title: "Thứ tự hiển thị",
      dataIndex: "index",
      className: "text-center",
      width: "5%",
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record, index) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record, index)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteSlider(index)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      fixed: "right",
    },
  ];

  const confirm = Modal.confirm;

  const showEditModal = (record, index) => {
    setEditModal(true);
    setTitleModal("Sửa slider");
    setImageNull(record.image);
    setValueFormData({
      product: record.product.id,
      index: record.index,
      itemIndex: index,
    });
    setIsModalEditVisible(true);
  };

  const showCreateModal = () => {
    setTitleModal("Thêm slider");
    setImageNull(null);
    setValueFormData({
      product: null,
      index: null,
      itemIndex: null,
    });
    setEditModal(false);
    setIsModalEditVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateSlider({ ...values, image: fileImageUrl });
      } else {
        if (fileImageUrl !== null) {
          createSlider({ ...values, image: fileImageUrl });
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Vui lòng tải ảnh lên!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      }
    },
    [isEditModal, fileImageUrl]
  );

  const createSlider = (data) => {
    const item = {
      product: data.product,
      index: data.index,
      image: data.image,
    };

    const mapData = sliderItems.map((item) => {
      return { product: item.product.id, index: item.index, image: item.image };
    });

    const payload = {
      "home-featured-products-slider": [...mapData, item],
    };

    actionApi(payload);
  };

  const updateSlider = (data) => {
    setLoading(true);
    const item = {
      product: data.product,
      index: data.index,
      image: data.image,
    };

    const mapData = sliderItems.map((item) => {
      return { product: item.product.id, index: item.index, image: item.image };
    });

    const newState = mapData.map((obj, index) => {
      if (index === data.itemIndex) {
        return { ...obj, ...item };
      }
      return obj;
    });

    const payload = {
      "home-featured-products-slider": newState,
    };

    actionApi(payload);
  };

  const deleteSlider = (index) => {
    console.log(index);
    confirm({
      title: "Bạn có muốn xóa slider này không?",
      onOk() {
        const items = sliderItems;
        items.splice(index, 1);

        const mapData = items.map((item) => {
          return {
            product: item.product.id,
            index: item.index,
            image: item.image,
          };
        });

        const payload = {
          "home-featured-products-slider": mapData,
        };
        actionApi(payload);
      },
      onCancel() {},
    });
  };

  const actionApi = (payload) => {
    setLoading(true);
    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Thao tác thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getHomeFeaturedProductsSlider();
          setIsModalEditVisible(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const closePopup = useCallback(() => {
    setValueFormData({
      product: null,
      index: null,
      itemIndex: null,
    });
    form.resetFields();
    setIsModalEditVisible(false);
  }, [form]);

  const forMap = (item) => {
    return (
      <div key={Math.random() * 100}>
        <div
          className="featured-img-1"
          style={{ backgroundImage: `url(${config.CDN_URL + item?.image})` , backgroundRepeat : 'no-repeat' , backgroundSize : 'cover' }}
        >
          {/* <span className="featured-img-1__tag">Sản phẩm mới</span>
          <div className="featured-img-1__info">
            <div className="featured-img-1__category">Loại sản phẩm</div>
            <div className="featured-img-1__name">{item?.product?.name}</div>
            <div className="featured-img-1__price">
              {currencyFormat(item?.product?.price || 0)} VNĐ
            </div>
          </div> */}
          {/* <Row align="center">
            <div className="featured-img-1__img">
              <LocalImage src={item?.image} alt="" width={150} />
            </div>
          </Row> */}
          <br />
          {/* <span className="featured-img-1__btn btn btn-primary">Chi tiết</span> */}
          <div className="featured-img-1__list-icon-btn">
            <span className="featured-img-1__heart-btn">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.7503 0.5C11.3003 0.5 9.90866 1.175 9.00033 2.24167C8.09199 1.175 6.70033 0.5 5.25033 0.5C2.68366 0.5 0.666992 2.51667 0.666992 5.08333C0.666992 8.23333 3.50033 10.8 7.79199 14.7L9.00033 15.7917L10.2087 14.6917C14.5003 10.8 17.3337 8.23333 17.3337 5.08333C17.3337 2.51667 15.317 0.5 12.7503 0.5ZM9.08366 13.4583L9.00033 13.5417L8.91699 13.4583C4.95033 9.86667 2.33366 7.49167 2.33366 5.08333C2.33366 3.41667 3.58366 2.16667 5.25033 2.16667C6.53366 2.16667 7.78366 2.99167 8.22533 4.13333H9.78366C10.217 2.99167 11.467 2.16667 12.7503 2.16667C14.417 2.16667 15.667 3.41667 15.667 5.08333C15.667 7.49167 13.0503 9.86667 9.08366 13.4583Z"
                  fill="#3FA000"
                ></path>
              </svg>
            </span>
            <span className="featured-img-1__cart-btn">
              <svg
                width="16"
                height="19"
                viewBox="0 0 16 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.625 3.75H11.75C11.75 1.67812 10.0719 0 8 0C5.92812 0 4.25 1.67812 4.25 3.75H2.375C1.34375 3.75 0.5 4.59375 0.5 5.625V16.875C0.5 17.9062 1.34375 18.75 2.375 18.75H13.625C14.6562 18.75 15.5 17.9062 15.5 16.875V5.625C15.5 4.59375 14.6562 3.75 13.625 3.75ZM8 1.875C9.03125 1.875 9.875 2.71875 9.875 3.75H6.125C6.125 2.71875 6.96875 1.875 8 1.875ZM13.625 16.875H2.375V5.625H4.25V7.5C4.25 8.01562 4.67188 8.4375 5.1875 8.4375C5.70312 8.4375 6.125 8.01562 6.125 7.5V5.625H9.875V7.5C9.875 8.01562 10.2969 8.4375 10.8125 8.4375C11.3281 8.4375 11.75 8.01562 11.75 7.5V5.625H13.625V16.875Z"
                  fill="#107B8C"
                ></path>
              </svg>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const getSlider = () => {
    return sliderItems.map(forMap);
    // const sliders = sliderItems.map((item) => {
    //   return {
    //     product: productsShow.find((product) => {
    //       return item.product == product.id;
    //     }),
    //     slider: item,
    //   };
    // });

    // if (sliders.length > 0) {
    //   return sliderItems.map(forMap);
    // }
  };

  const slidersHtml = getSlider();

  return (
    <>
      <div className="tabled">
        <Space size={10}>
          <Button type="dashed" onClick={() => showCreateModal()} size="small">
            <EditOutlined /> &nbsp; Thêm slider
          </Button>
        </Space>
        <br />
        <br />
        <Row gutter={[24, 0]}>
          <Col span={14}>
            <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
              <div className="table-responsive">
                <Table
                  rowKey={(record) => record.index + Math.random() * 100}
                  loading={loading}
                  columns={columns}
                  dataSource={sliderItems}
                  className="ant-border-space"
                  pagination={{
                    position: ["none"],
                  }}
                />
              </div>
            </Card>
          </Col>
          <Col span={6} offset={2} className="mt-10">
            <div style={{ maxWidth: "285px" }}>
              <Slider
                dots={true}
                slidesToShow={1}
                infinite={true}
                slidesToScroll={1}
              >
                {slidersHtml}
              </Slider>
            </div>
          </Col>
        </Row>
        <Modal
          title={titleModal}
          visible={isModalEditVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              initialValues={valueFormData}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="itemIndex" name="itemIndex">
                <Input />
              </Form.Item>

              <Form.Item
                label="Sản phẩm"
                name="product"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn!",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  placeholder="Chọn sản phẩm..."
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {products == null ||
                  products === "undefined" ||
                  products === []
                    ? []
                    : products.map((item, key) => (
                        <Option key={key} value={item.value}>
                          {item.text}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Thứ tự hiển thị"
                name="index"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập thứ tự hiển thị!",
                  },
                ]}
              >
                <InputNumber min={0} />
              </Form.Item>

              <Form.Item label="Ảnh hiển thị" name="image">
                <UploadFile />
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default SliderProduct;
